import { SettingOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input, InputNumber, Popover } from 'antd';
import { on } from 'events';
import { useEffect, useRef } from 'react';

export function MiniSDSSettingsForm(props: { settings: any; onChange: (settings: any) => void }) {
  const [form] = Form.useForm();

  const kararlilik = useRef<HTMLDivElement>(null);
  const ellecleme = useRef<HTMLDivElement>(null);
  const maruzKalma = useRef<HTMLDivElement>(null);

  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    form.setFieldsValue(props.settings);
  }, [props.settings]);

  const focusIn = (ref: string) => {
    if (kararlilik.current && ellecleme.current && maruzKalma.current) {
      switch (ref) {
        case 'kararlilik':
          {
            kararlilik.current.style.border = '3px solid white';
            kararlilik.current.style.opacity = '1';
            ellecleme.current.style.removeProperty('border');
            ellecleme.current.style.opacity = '0.8';
            maruzKalma.current.style.removeProperty('border');
            maruzKalma.current.style.opacity = '0.8';
          }
          break;
        case 'ellecleme':
          {
            ellecleme.current.style.border = '3px solid white';
            ellecleme.current.style.opacity = '1';
            kararlilik.current.style.removeProperty('border');
            kararlilik.current.style.opacity = '0.8';
            maruzKalma.current.style.removeProperty('border');
            maruzKalma.current.style.opacity = '0.8';
          }
          break;
        case 'maruzKalma':
          {
            maruzKalma.current.style.border = '3px solid white';
            maruzKalma.current.style.opacity = '1';
            kararlilik.current.style.removeProperty('border');
            kararlilik.current.style.opacity = '0.8';
            ellecleme.current.style.removeProperty('border');
            ellecleme.current.style.opacity = '0.8';
          }
          break;
        default:
          break;
      }
    }
  };

  const inputChange = (ref: string, target: React.MutableRefObject<HTMLDivElement | null>, value: string) => {
    const reg = /^-?\d*(\.\d*)?$/;
    if (reg.test(value)) {
      if (target.current) target.current.style.fontSize = `${value}pt`;
      props.onChange({ ...props.settings, [ref]: value });
    } else {
      const numericValue = value.replace(/[^0-9.]/g, '');
      form.setFieldsValue({ [ref]: numericValue });
      form.validateFields([ref]);
    }
  };

  return (
    <Popover
      ref={popupRef}
      trigger="click"
      placement="right"
      content={
        <div style={{ display: 'flex', gap: '1rem' }}>
          <Card title="Önizleme" size="small">
            <div>
              <div style={{ width: '200px', height: '283px', display: 'flex' }}>
                <div style={{ width: '50%', height: '100%' }}>
                  <div style={{ opacity: '0.6', width: '100%', height: '10%' }}></div>
                  <div style={{ opacity: '0.6', width: '100%', height: '10%', background: '#2F74B5' }}></div>
                  <div ref={kararlilik} style={{ opacity: '0.6', width: '100%', height: '60%', background: '#8295B0', overflow: 'hidden' }}>
                    metin
                  </div>
                  <div ref={ellecleme} style={{ opacity: '0.6', width: '100%', height: '20%', background: '#2F5495', overflow: 'hidden' }}>
                    metin
                  </div>
                </div>
                <div style={{ width: '50%', height: '100%' }}>
                  <div style={{ opacity: '0.6', width: '100%', height: '20%', background: '#42546A' }}></div>
                  <div ref={maruzKalma} style={{ opacity: '0.6', width: '100%', height: '80%', background: '#7B7B7B', overflow: 'hidden' }}>
                    metin
                  </div>
                </div>
              </div>
            </div>
          </Card>

          <Card title="Mini SDS font ayarları" size="small">
            <Form labelCol={{ span: 30 }} wrapperCol={{ span: 30 }} form={form} layout="vertical" name="basic">
              <Form.Item label="Kararlılık ve tepkime font boyutu" name="ktFontSize">
                <Input
                  inputMode="numeric"
                  onFocus={() => focusIn('kararlilik')}
                  onChange={e => {
                    inputChange('ktFontSize', kararlilik, e.target.value);
                  }}
                />
              </Form.Item>
              <Form.Item label="Elleçleme ve depolama font boyutu" name="edFontSize">
                <Input
                  inputMode="numeric"
                  onFocus={() => focusIn('ellecleme')}
                  onChange={e => {
                    inputChange('edFontSize', ellecleme, e.target.value);
                  }}
                />
              </Form.Item>
              <Form.Item label="Maruz kalma ve dökülme font boyutu" name="mdFontSize">
                <Input
                  inputMode="numeric"
                  onFocus={() => focusIn('maruzKalma')}
                  onChange={e => {
                    inputChange('mdFontSize', maruzKalma, e.target.value);
                  }}
                />
              </Form.Item>
            </Form>
          </Card>
        </div>
      }
    >
      <Button type="ghost" size="small">
        <SettingOutlined />
      </Button>
    </Popover>
  );
}
